package com.essntl.core.twilio.di

import com.essntl.core.twilio.data.TwilioClientImpl
import com.essntl.core.twilio.domain.TwilioClient
import org.koin.dsl.module

val twilioModule
    get() =
        module {
            single<TwilioClient> { TwilioClientImpl(get()) }
        }
